var ReadProgress = (function($) {

  var _s = {
    el: '.read-progress',
    container_el: '.read-progress-container',
    content_container_el: '.post-content-container'
  };

  var _init = function() {
    _bindEvents();

    let offset = $('header').outerHeight();
    $(_s.container_el).css('top',offset+'px');
    
    $(window).trigger('scroll');
  };

  var _bindEvents = function() {
    // ### Scroll Watch
    $(window).on("scroll", function() {
      let pos = $(document).scrollTop();
      let pos_middle = pos + ($(window).height() / 2);

      let content_top = $(_s.content_container_el).offset().top;
      let content_height = $(_s.content_container_el).outerHeight();
      
      let pos_percent = (pos_middle - content_top) / content_height;

      if ( pos_percent > 0 && pos_percent < 1 ) {
        $(_s.el).css('transform', 'scaleX('+pos_percent.toFixed(2)+')');
      } else if ( pos_percent >= 1 ) {
        $(_s.el).css('transform', 'scaleX(1)');
      } else if ( pos_percent <= 0 ) {
        $(_s.el).css('transform', 'scaleX(0)');
      }

    });
  
  };

  return {
    init: _init
  };

})(jQuery);